import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {LocaleHandler} from '../libraries/locale-handler';
import {RequestExecutor} from '../libraries/request-executor';
import {ConversationId} from '../libraries/conversation-id';
import {Constants} from '../constants';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class TranslationsService extends RequestExecutor {
    /**
     * Translations object
     * @var {object}
     */
    private _translations: object = {};

    /**
     * Class constructor
     *
     * @param _localeHandler
     * @param _conversationId
     * @param _httpClient
     */
    constructor(
        private _localeHandler: LocaleHandler,
        protected _conversationId: ConversationId,
        protected _httpClient: HttpClient
    ) {
        super(_conversationId, _httpClient);
    }

    /**
     * Sets the current request headers
     *
     * @param requestHeaders
     * @returns {TranslationsService}
     */
    public setRequestHeaders(requestHeaders?: object): TranslationsService {
        super.setRequestHeaders(requestHeaders || {});

        return this;
    }

    /**
     * Sets the current request body
     *
     * @param requestBody
     * @returns {TranslationsService}
     */
    public setRequestBody(requestBody?: object): TranslationsService {
        super.setRequestBody(requestBody || {});

        return this;
    }

    /**
     * Sets the current request params
     *
     * @param requestParams
     * @returns {TranslationsService}
     */
    public setRequestParams(requestParams?: object): TranslationsService {
        super.setRequestParams(requestParams || {});

        return this;
    }

    /**
     * Return the loaded translations object
     *
     * @returns {object}
     */
    public getTranslations(): object {
        return this._translations;
    }

    /**
     * Loads the translations from the API endpoint based on the current locale
     *
     * @returns {Promise<any>}
     */
    public loadTranslations(): Promise<any> {
        return new Promise((resolve, reject) => {
            this
                .setRequestHeaders()
                .setRequestParams({
                    'contentKey': Constants.PARAM_CONTENT_KEY,
                    'lang': this._localeHandler.getCurrentPreferredLanguage()
                })
                .executeRequest(
                    Constants.REQUEST_TYPE_GET,
                    `${environment.comSharedApi.basePath}${environment.comSharedApi.paths.content}`
                )
                .subscribe(
                    (translations: any) => {
                        this._translations = translations;
                        resolve(translations);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
        });
    }
}
